import { useLocation, useNavigate } from 'react-router-dom';
import patterns from '../data/patterns';
import { HomeIcon, MenuIcon, CloseIcon } from './Icons';

/**
 * Fixed left sidebar with section-grouped navigation.
 *
 * Props:
 *   open     — boolean, controls mobile slide-in
 *   onToggle — () => void, toggles mobile sidebar
 */
export default function Sidebar({ open, onToggle }) {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;

  function go(to) {
    navigate(to);
    onToggle();
  }

  return (
    <>
      {/* Mobile hamburger */}
      <button className="sidebar-mobile-toggle" onClick={onToggle}>
        {open ? <CloseIcon /> : <MenuIcon />}
      </button>

      {/* Overlay */}
      {open && <div className="sidebar-overlay" onClick={onToggle} />}

      {/* Sidebar */}
      <nav className={`sidebar ${open ? 'open' : ''}`}>
        <div className="sidebar-logo">
          <h1>
            <span className="highlight">AI</span> Patterns for{' '}
            <span className="accent">DevOps</span>
          </h1>
          <p>Practical AI for Infrastructure</p>
        </div>

        <div className="sidebar-nav">
          {/* Home */}
          <div className="sidebar-section">
            <div
              className={`sidebar-link ${path === '/' ? 'active' : ''}`}
              onClick={() => go('/')}
            >
              <HomeIcon />
              Home
            </div>
          </div>

          {/* AI Fundamentals */}
          <div className="sidebar-section">
            <div className="sidebar-section-title">AI Fundamentals</div>
            {patterns.map((p) => (
              <div
                key={p.id}
                className={`sidebar-link ${path === `/patterns/${p.id}` ? 'active' : ''}`}
                onClick={() => go(`/patterns/${p.id}`)}
              >
                <span className="dot" style={{ background: p.color }} />
                {p.title}
              </div>
            ))}
          </div>

          {/* Prompt Library */}
          <div className="sidebar-section">
            <div className="sidebar-section-title">Prompt Engineering</div>
            <div
              className={`sidebar-link ${path === '/prompts' || path.startsWith('/prompts/') ? 'active' : ''}`}
              onClick={() => go('/prompts')}
            >
              <span className="dot" style={{ background: '#38bdf8' }} />
              Prompt Library
            </div>
          </div>

          {/* Our System */}
          <div className="sidebar-section">
            <div className="sidebar-section-title">Our System</div>
            <div
              className={`sidebar-link ${path === '/agents' ? 'active' : ''}`}
              onClick={() => go('/agents')}
            >
              <span className="dot" style={{ background: '#f472b6' }} />
              Multi-Agent System
            </div>
            <div
              className={`sidebar-link ${path === '/learning' ? 'active' : ''}`}
              onClick={() => go('/learning')}
            >
              <span className="dot" style={{ background: '#fbbf24' }} />
              Learning Path
            </div>
          </div>
        </div>

        <div className="sidebar-footer">
          Powered by{' '}
          <a href="https://www.whoisdevops.com" target="_blank" rel="noopener noreferrer" className="sidebar-footer-brand">
            <span className="sidebar-footer-cmd">$whois</span><span className="sidebar-footer-cursor">_</span>{' '}
            <span className="sidebar-footer-devops">DevOps</span>
          </a>
        </div>
      </nav>
    </>
  );
}
